import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  handpickedRelatedArticles: 'Hand-picked related articles',
  latest: 'Latest from inside the mix…',
  more: 'More from inside the mix…',
  newsroom: 'Newsroom',
  resultsFound: 'results found',
  searchNewsroom: 'Search Newsroom',
}
export const blogStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
